// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#header .header-avatar[data-v-8e7769ae]{width:50px}#header .header-btns[data-v-8e7769ae]{padding:30px 15px}", ""]);
// Exports
module.exports = exports;
